import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { useQuery } from "@tanstack/react-query";

import { getUser2FAStatusQueryDocument } from "./two-factor-auth.gql";

export interface User2FAStatus {
  id: string;
  userId: string;
  isEnabled: boolean;
  lastVerifiedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const useGetUser2FAStatus = () => {
  return useQuery({
    queryKey: ["getUser2FAStatus"],
    queryFn: async () => {
      const client = createOperationClient("getUser2FAStatus");
      const data = await client.request(getUser2FAStatusQueryDocument, {});

      return data.getUser2FAStatus;
    },
  });
};
